module.exports = __webpack_public_path__ + "img/symbol_13.a04b669d.png";